import React, { FC } from 'react';
import { ImageLoader } from './ImageLoader';
import { ImageLazyLoader } from './ImageLazyLoader';

interface ImageProps {
  src: string;
  alt?: string;
  srcSet?: string;
  onLoad?: Function;
  width?: string | number | string[] | number[];
  height?: string | number | string[] | number[];
  lazy?: boolean;
  cover?: boolean;
  [key: string]: any;
}

export const Image: FC<ImageProps> = React.memo(
  ({ alt = 'alt', lazy = false, cover = true, ...rest }: ImageProps) => {
    const InnerImage = lazy ? ImageLazyLoader : ImageLoader;
    return <InnerImage alt={alt} cover={cover} {...rest} />;
  }
);
